<template>
    <intersect @on="mobileEnter" @off="mobileLeave" :threshold="0.75">
        <div class="overflow-hidden position-relative" :style="heightStyle" v-bind="$attrs">
            <template v-if="imagesList">
                <transition name="fade-transition-scale" @after-enter="switchImages">
                    <card-image v-if="nextImage" :src="nextImage" :autoLoad="true" :background="true" :height="computedHeight" />
                </transition>
                <card-image :src="displayImage" :autoLoad="autoLoadImage" :background="true" :height="computedHeight" />
            </template>
            <card-image v-else :src="image" :background="true" :height="computedHeight" />
        </div>
    </intersect>
</template>

<script type="text/javascript">
    import ApiConfig from '@/config/api.json';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        inheritAttrs: false,

        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                displayImage: null,
                nextImage: null,
                rotateTimer: null,
                displayImageIndex: 0,
                rotatingImages: false,
                autoLoadImage: false,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            height: {
                type: [Number, String],
                default: null,
            },

            cardHover: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['select'],

        created() {
            if (this.imagesList) {
                this.displayImage = this.imagesList[0];
            }
        },

        watch: {
            cardHover() {
                if (this.cardHover) {
                    this.mouseEnter();
                }
                else {
                    this.mouseLeave();
                }
            }
        },

        computed: {
            imagesList() {
                if ((this.property) && (this.property.photosList) && (this.property.photosList.length)) {
                    return this.property.photosList;
                }
                return null;
            },

            image() {
                if ((this.property) && (this.property.photosList) && (this.property.photosList.length)) {
                    return this.property.photosList[0];
                }

                let firstPhoto;
                if ((this.property) && (this.property.firstPhoto)) {
                    firstPhoto = this.property.firstPhoto;
                }
                else if ((this.property) && (this.property.photos) && (this.property.photos.length)) {
                    firstPhoto = this.property.photos[0];
                }

                if (firstPhoto) {
                    if (firstPhoto.cdnImages) {
                        let sizes = ['singleGalleryThumbnail', 'single', 'singleGalleryThumbnail', 'gallery', 'singleHeader', 'homeaway'];
                        for (let i=0; i<sizes.length; i++) {
                            if (firstPhoto.cdnImages[sizes[i]]) {
                                return firstPhoto.cdnImages[sizes[i]];
                            }
                        }
                    }
                    else if (firstPhoto.galleryThumbSource) {
                        return firstPhoto.galleryThumbSource;
                    }
                    else if (firstPhoto.gallerySource) {
                        return firstPhoto.gallerySource;
                    }
                }

                return '/img/owner/default-home.jpg';
            },

            computedHeight() {
                if (!this.height) {
                    return 225;
                }
                return this.height;
            },

            heightStyle() {
                if (typeof this.computedHeight == 'number') {
                    return 'height:'+this.computedHeight+'px';
                }

                return 'height:'+this.computedHeight;
            },
        },

        methods: {
            mouseEnter() {
                if (this.uiStore.isMobile) return;
                this.startRotation(500);
            },

            mobileEnter() {
                if (!this.uiStore.isMobile) return;
                this.startRotation(3000);
            },

            startRotation(delay) {
                if (this.rotatingImages) return;

                this.rotatingImages = true;
                this.autoLoadImage = true;
                clearTimeout(this.rotateTimer);
                this.rotateTimer = setTimeout(this.rotateImage, delay);
            },

            mouseLeave() {
                if (this.uiStore.isMobile) return;
                this.endRotation();
            },

            mobileLeave() {
                if (!this.uiStore.isMobile) return;
                this.endRotation();
            },

            endRotation() {
                clearTimeout(this.rotateTimer);
                this.rotatingImages = false;
                this.nextImage = null;
                if (this.imagesList) {
                    this.displayImage = this.imagesList[0];
                }
            },

            rotateImage() {
                if (!this.imagesList) {
                    return;
                }
                clearTimeout(this.rotateTimer);

                this.displayImageIndex++;
                if (this.displayImageIndex >= this.imagesList.length) {
                    this.displayImageIndex = 0;
                }

                let source = this.imagesList[this.displayImageIndex];

                let img = new Image()
                img.onload = function() {
                    if (!this.rotatingImages) {
                        return;
                    }
                    this.nextImage = source;

                }.bind(this);

                img.onerror = function() {
                    this.rotateImage();
                }.bind(this);

                img.src = source.replace('[PCDN]', ApiConfig.propertyImagesCDN).replace('[CDN]', ApiConfig.imagesCDN);
            },

            switchImages() {
                if (this.nextImage) {
                    this.displayImage = this.nextImage;
                }

                this.nextImage = null;

                if (this.rotatingImages) {
                    this.rotateTimer = setTimeout(this.rotateImage, 3000);
                }
            },
        }
    };

</script>
